import React from 'react';
import { DesktopTableCell } from '../DesktopTableCell';

export const DesktopTableRow = ({
    rowData,
    levelsNum,
    isLastRow,
}) => {
    const {
        title,
        same_for_all,
    } = rowData;

    let cellSpan = '';
    const cellValues = [];

    if (same_for_all) {
        cellSpan = levelsNum;
        cellValues.push(rowData['unified_value']);
    } else {
        cellSpan = 1;
        for (let l = 1; l <= levelsNum; l++) {
            cellValues.push(rowData[`level_${l}`]);
        }
    }

    const cellBaseClass = 'loyalty-levels-table-desktop__cell';
    const cellClass = [
        cellBaseClass,
        isLastRow ? `${cellBaseClass}--last-row` : '',
    ].join(' ');

    return <>
        <div className={`${cellClass} ${cellBaseClass}-title`}>
            {title}
        </div>
        {cellValues.map((cellValue, index) => <DesktopTableCell
            key={index}
            value={cellValue}
            span={cellSpan}
            extraClass={cellClass}
        />)}
    </>;
};
